(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const findHeaderSection = element =>
      element.closest('.section-header') ||
      document.querySelector('.section-header');

    const addMediaQueryListener = (mediaQuery, handler) => {
      if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', handler);
        return () => mediaQuery.removeEventListener('change', handler);
      }

      mediaQuery.addListener(handler);
      return () => mediaQuery.removeListener(handler);
    };

    if (!customElements.get('sticky-header')) {
      class StickyHeader extends HTMLElement {
        connectedCallback() {
          this.header = findHeaderSection(this);

          if (!this.header) {
            return;
          }

          this.headerIsAlwaysSticky =
            this.getAttribute('data-sticky-type') === 'always' ||
            this.getAttribute('data-sticky-type') === 'reduce-logo-size';

          this.headerBounds = this.header.getBoundingClientRect();
          this.currentScrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
          this.preventReveal = false;
          this.predictiveSearches = [
            ...this.querySelectorAll('predictive-search')
          ];
          this.searchModals = [
            ...this.querySelectorAll('details-modal')
          ];
          this.disclosures = [
            ...this.header.querySelectorAll('header-menu')
          ];

          this.onScrollHandler = this.onScroll.bind(this);
          this.onBreakpointChange = this.setHeaderHeight.bind(this);
          this.hideHeaderOnScrollUp = () => {
            this.preventReveal = true;
          };

          this.breakpointQuery = window.matchMedia('(max-width: 989px)');
          this.removeBreakpointListener = addMediaQueryListener(
            this.breakpointQuery,
            this.onBreakpointChange
          );

          this.setHeaderHeight();

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          }

          this.addEventListener(
            'preventHeaderReveal',
            this.hideHeaderOnScrollUp
          );
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        disconnectedCallback() {
          if (this.hideHeaderOnScrollUp) {
            this.removeEventListener(
              'preventHeaderReveal',
              this.hideHeaderOnScrollUp
            );
          }

          if (this.onScrollHandler) {
            window.removeEventListener('scroll', this.onScrollHandler);
          }

          if (typeof this.removeBreakpointListener === 'function') {
            this.removeBreakpointListener();
          }

          if (this.headerObserver) {
            this.headerObserver.disconnect();
            this.headerObserver = null;
          }

          window.clearTimeout(this.isScrolling);
        }

        setHeaderHeight() {
          if (!this.header) {
            return;
          }

          document.documentElement.style.setProperty(
            '--header-height',
            `${this.header.offsetHeight}px`
          );
        }

        createObserver() {
          if (!('IntersectionObserver' in window) || !this.header) {
            return;
          }

          this.headerObserver = new IntersectionObserver(entries => {
            const entry = entries[0];

            if (entry) {
              this.headerBounds = entry.intersectionRect;
            }

            if (this.headerObserver) {
              this.headerObserver.disconnect();
              this.headerObserver = null;
            }
          });

          this.headerObserver.observe(this.header);
        }

        isSearchOpen() {
          const predictiveSearchIsOpen = this.predictiveSearches.some(
            predictiveSearch => predictiveSearch.isOpen
          );

          const searchModalIsOpen = this.searchModals.some(searchModal =>
            Boolean(searchModal.querySelector('details[open]'))
          );

          return predictiveSearchIsOpen || searchModalIsOpen;
        }

        onScroll() {
          if (!this.header || this.isSearchOpen()) {
            return;
          }

          const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
          const headerBottom = Number(this.headerBounds?.bottom) || 0;
          const headerTop = Number(this.headerBounds?.top) || 0;

          if (
            scrollTop > this.currentScrollTop &&
            scrollTop > headerBottom
          ) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventHide) {
              requestAnimationFrame(() => this.hide());
            }
          } else if (
            scrollTop < this.currentScrollTop &&
            scrollTop > headerBottom
          ) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(() => this.reveal());
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = window.setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(() => this.hide());
            }
          } else if (scrollTop <= headerTop) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(() => this.reset());
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
          if (!this.header || this.headerIsAlwaysSticky) {
            return;
          }

          this.header.classList.add(
            'shopify-section-header-hidden',
            'shopify-section-header-sticky'
          );
          this.closeMenuDisclosure();
          this.closeSearchModals();
        }

        reveal() {
          if (!this.header || this.headerIsAlwaysSticky) {
            return;
          }

          this.header.classList.add(
            'shopify-section-header-sticky',
            'animate'
          );
          this.header.classList.remove('shopify-section-header-hidden');
        }

        reset() {
          if (!this.header || this.headerIsAlwaysSticky) {
            return;
          }

          this.header.classList.remove(
            'shopify-section-header-hidden',
            'shopify-section-header-sticky',
            'animate'
          );
        }

        closeMenuDisclosure() {
          this.disclosures.forEach(disclosure => {
            if (typeof disclosure.close === 'function') {
              disclosure.close();
            }
          });
        }

        closeSearchModals() {
          this.searchModals.forEach(searchModal => {
            if (typeof searchModal.close === 'function') {
              searchModal.close(false);
              return;
            }

            const openDetails = searchModal.querySelector('details[open]');

            if (openDetails) {
              openDetails.removeAttribute('open');
            }
          });
        }
      }

      customElements.define('sticky-header', StickyHeader);
    }

    if (!customElements.get('static-header')) {
      class StaticHeader extends HTMLElement {
        connectedCallback() {
          this.header = findHeaderSection(this);

          if (!this.header) {
            return;
          }

          this.onBreakpointChange = this.setHeaderHeight.bind(this);
          this.breakpointQuery = window.matchMedia('(max-width: 989px)');
          this.removeBreakpointListener = addMediaQueryListener(
            this.breakpointQuery,
            this.onBreakpointChange
          );

          this.setHeaderHeight();
        }

        disconnectedCallback() {
          if (typeof this.removeBreakpointListener === 'function') {
            this.removeBreakpointListener();
          }
        }

        setHeaderHeight() {
          if (!this.header) {
            return;
          }

          document.documentElement.style.setProperty(
            '--header-height',
            `${this.header.offsetHeight}px`
          );
        }
      }

      customElements.define('static-header', StaticHeader);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
